import React, { useEffect, useRef } from 'react'
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import useTestAttribute from '../hooks/useTestAttribute'

const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  option: {
    padding: spacing(1, 0),
    borderBottom: '1px solid #ececec'
  },
  label: {
    color: palette.common.black,
    ...typography.body.s
  }
}))

const CheckboxGroup = ({
  options,
  value = [],
  onChange,
  autoFocus,
  'data-test': dataTest = 'checkbox-group'
}) => {
  const classes = useStyles()
  const testAttr = useTestAttribute(dataTest)
  const actionRef = useRef()
  const inputRef = useRef()

  useEffect(() => {
    const focusFirstOption = () => {
      inputRef.current?.focus()
      actionRef.current?.focusVisible()
    }

    if (autoFocus) {
      focusFirstOption()
    }
  }, [autoFocus])

  const handleChange = ({ target: { name, checked } }) => {
    const newValue = checked ? [...value, name] : value.filter(v => v !== name)
    onChange(newValue)
  }

  const refForFirst = (ref, index) => (index === 0 ? ref : undefined)

  return (
    <FormGroup data-test={dataTest}>
      {options.map((opt, index) => (
        <FormControlLabel
          control={
            <Checkbox
              checked={value.includes(opt.value)}
              size='small'
              color='primary'
              name={opt.value}
              onChange={handleChange}
              inputRef={refForFirst(inputRef, index)}
              action={refForFirst(actionRef, index)}
              inputProps={{
                'data-test': testAttr(index, 'input')
              }}
            />
          }
          label={<span data-test={testAttr(index, 'label')}>{opt.label}</span>}
          key={opt.value}
          classes={{ root: classes.option, label: classes.label }}
        />
      ))}
    </FormGroup>
  )
}

export default CheckboxGroup
